import { useTranslation } from "react-i18next";
import PaymentCard from "../../../components/payment/PaymentCard";
import SubscriptionDetails from "../../../components/payment/SubscriptionDetails";
import { makeApiRequest } from "../../../helpers";
import { ApiResponse } from "../../../api/apiResponse";
import { candidateSubscriptionPayment } from "../../../api/endpoints/candidate/payment";
import moment from "moment";
import { useEffect, useState } from "react";

export default function PaymentPage() {
  const { t } = useTranslation("", {
    keyPrefix: "page.candidate.dashboard.payment",
  });
  const [clientSecret, setClientSecret] = useState<string | null>(null);

  const getPaymentToken = () => {
    const data = {
      expired_at: moment().add(30, "days").format("DD/MM/YYYY"),
      amount: 3500,
    };
    makeApiRequest(
      () => candidateSubscriptionPayment(data),
      (response: ApiResponse) => {
        const { data } = response;
        const { payments } = data;
        if (payments.length)
          setClientSecret(payments[payments?.length - 1]?.client_secret);
      }
    );
  };
  useEffect(() => {
    getPaymentToken();
  }, []);
  return (
    <div className="w-full h-screen sm:min-h-[90vh] bg-gray-50">
      <div className="w-full border-b border-gray-200 py-6 px-4 md:px-6">
        <h3 className="w-full mb-1 text-lg leading-6 text-gray-900 font-medium">
          {t("paymentSubscriptions")}
        </h3>
        <p className="w-full text-gray-500 text-sm font-normal">
          {t("paymentDetails")}
        </p>
      </div>
      <div className="w-full  grid grid-cols-1 md:grid-cols-2 md:gap-2  items-start mt-6">
        <div className="w-full  px-4 md:px-6">
          <SubscriptionDetails cost={"35.00"} paymentDetails={true} />
        </div>
        <div className="w-full rtl:mr-3 ltr:ml-3 sm:ltr:mr-0 rtl:pl-4 ltr:pr-4 md:ltr:pr-6 md:rtl:pl-6">
          {!!clientSecret && (
            <PaymentCard
              redirectTo={`${window.location.origin}/candidate/schedule`}
              clientSecret={clientSecret}
            />
          )}
        </div>
      </div>
    </div>
  );
}
